(function () {
  'use strict';

  var STYLE_ID = 'so-pdp-atc-label-fix-style';
  var SYNC_DELAY_MS = 40;
  var FORCED_DISABLED_ATTR = 'data-so-inventory-forced-disabled';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '[id^="so-pdp-"] .so-pdp-atc,',
      '[id^="so-pdp-"] .so-pdp-mobile-buy button[type="submit"] {',
      '  position: relative !important;',
      '}',
      '[id^="so-pdp-"] .so-pdp-atc > span,',
      '[id^="so-pdp-"] .so-pdp-mobile-buy button[type="submit"] > span {',
      '  visibility: hidden !important;',
      '}',
      '[id^="so-pdp-"] .so-pdp-atc::after,',
      '[id^="so-pdp-"] .so-pdp-mobile-buy button[type="submit"]::after {',
      '  content: attr(data-so-atc-label);',
      '  position: absolute;',
      '  inset: 0;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  padding: inherit;',
      '  color: #fff;',
      '  font: inherit;',
      '  font-weight: inherit;',
      '  line-height: 1.1;',
      '  white-space: nowrap;',
      '  pointer-events: none;',
      '}',
      '[id^="so-pdp-"] .so-pdp-atc[disabled]::after {',
      '  color: #66705f;',
      '}',
      '[id^="so-pdp-"] .so-pdp-mobile-buy button[type="submit"][disabled]::after {',
      '  color: #fff !important;',
      '}',
      '[id^="so-pdp-"] .so-pdp-mobile-buy button[type="submit"][disabled] {',
      '  color: #fff !important;',
      '}',
      '[id^="so-pdp-"] .so-pdp-media-count {',
      '  display: none !important;',
      '}',
      '[id^="so-pdp-"] [data-so-sticky-price] {',
      '  display: inline-block;',
      '  margin-left: 6px;',
      '  font-weight: 800;',
      '  white-space: nowrap;',
      '}',
      '@media (max-width: 749px) {',
      '  body:has([id^="so-pdp-"] .so-pdp-mobile-buy) {',
      '    padding-bottom: calc(96px + env(safe-area-inset-bottom)) !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function getAlpineState(root) {
    if (!root) return null;

    if (window.Alpine && typeof window.Alpine.$data === 'function') {
      try {
        var state = window.Alpine.$data(root);
        if (state) return state;
      } catch (error) {}
    }

    if (root._x_dataStack && root._x_dataStack.length) return root._x_dataStack[0];
    return null;
  }

  function getVariantId(root) {
    var state = getAlpineState(root);
    if (state && state.selectedVariantId !== undefined && state.selectedVariantId !== null && state.selectedVariantId !== '') {
      return String(state.selectedVariantId);
    }

    var input = root.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);

    var onlyVariant = root.querySelectorAll('.so-pdp-variant');
    if (onlyVariant.length === 1) {
      var expression = onlyVariant[0].getAttribute('@click') || onlyVariant[0].getAttribute('x-on:click') || '';
      var match = expression.match(/selectVariant\(\s*(\d+)/);
      if (match) return String(match[1]);
    }

    return '';
  }

  function getVariantControl(root, variantId) {
    var buttons = root.querySelectorAll('.so-pdp-variant');
    if (!buttons.length) return null;

    if (variantId) {
      for (var i = 0; i < buttons.length; i += 1) {
        var explicitId = buttons[i].getAttribute('data-variant-id');
        if (explicitId && String(explicitId) === String(variantId)) return buttons[i];

        var expression = buttons[i].getAttribute('@click') || buttons[i].getAttribute('x-on:click') || '';
        var match = expression.match(/selectVariant\(\s*(\d+)/);
        if (match && String(match[1]) === String(variantId)) return buttons[i];
      }
    }

    var selected = root.querySelector('.so-pdp-variant.is-selected');
    if (selected) return selected;
    if (buttons.length === 1) return buttons[0];
    return null;
  }

  function getInventoryRecord(variantId) {
    var inventory = window.__SO_PRODUCT_INVENTORY__;
    if (!variantId || !inventory || !inventory.variants) return null;
    return inventory.variants[String(variantId)] || null;
  }

  function exactInventoryAvailability(record) {
    if (!record) return null;
    if (record.available === false) return false;

    var managed = record.inventory_management !== null &&
      record.inventory_management !== false &&
      record.inventory_management !== '';
    var policy = String(record.inventory_policy || '').toLowerCase();
    var quantity = Number(record.inventory_quantity);

    if (managed && policy !== 'continue' && Number.isFinite(quantity) && quantity <= 0) return false;
    return true;
  }

  function getAvailability(root, variantId, mainButton) {
    var control = getVariantControl(root, variantId);

    if (control) {
      if (control.disabled || control.hasAttribute('disabled') || control.getAttribute('data-sold-out') === 'true') {
        return false;
      }
    }

    var exact = exactInventoryAvailability(getInventoryRecord(variantId));
    if (typeof exact === 'boolean') return exact;

    if (control) return true;
    return mainButton ? !mainButton.disabled : true;
  }

  function moneyFromCents(value) {
    var cents = Number(value);
    if (!Number.isFinite(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantPrice(root, variantId) {
    var control = getVariantControl(root, variantId);
    if (control) {
      var controlPrice = control.querySelector('.so-pdp-variant__price');
      if (controlPrice && controlPrice.textContent.trim()) return controlPrice.textContent.trim();
    }

    var state = getAlpineState(root);
    if (state && state.product && Array.isArray(state.product.variants)) {
      var stateVariant = state.product.variants.find(function (variant) {
        return String(variant && variant.id) === String(variantId);
      });
      if (stateVariant && stateVariant.price !== undefined && stateVariant.price !== null) {
        var statePrice = moneyFromCents(stateVariant.price);
        if (statePrice) return statePrice;
      }
    }

    var firstPrice = root.querySelector('.so-pdp-variant__price');
    if (firstPrice && firstPrice.textContent.trim()) return firstPrice.textContent.trim();

    var stickyPrice = root.querySelector('.so-pdp-mobile-buy__product strong, .so-pdp-mobile-buy [data-so-sticky-price]');
    return stickyPrice && stickyPrice.textContent.trim() ? stickyPrice.textContent.trim() : '';
  }

  function setLabel(button, label) {
    if (!button) return;
    button.setAttribute('data-so-atc-label', label);
    button.setAttribute('aria-label', label);
  }

  function setInventoryDisabled(button, soldOut) {
    if (!button) return;

    if (soldOut) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute(FORCED_DISABLED_ATTR, 'true');
      return;
    }

    if (button.getAttribute(FORCED_DISABLED_ATTR) === 'true') {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.removeAttribute(FORCED_DISABLED_ATTR);
    }
  }

  function syncStickyPrice(root, price, mobileButton) {
    if (!price) return;

    var sticky = root.querySelector('.so-pdp-mobile-buy');
    if (!sticky) return;

    var productInfo = sticky.querySelector('.so-pdp-mobile-buy__product');
    if (productInfo) {
      var priceNode = productInfo.querySelector('strong, [data-so-sticky-price]');
      if (!priceNode) {
        priceNode = document.createElement('strong');
        productInfo.appendChild(priceNode);
      }
      priceNode.setAttribute('data-so-sticky-price', 'true');
      priceNode.textContent = price;
      return;
    }

    var existing = sticky.querySelector('[data-so-sticky-price]');
    if (existing) {
      existing.textContent = price;
      return;
    }

    var children = Array.prototype.slice.call(sticky.children || []);
    var target = children.find(function (child) {
      return child !== mobileButton && child.tagName !== 'BUTTON';
    });
    if (!target) return;

    var fallbackPrice = document.createElement('strong');
    fallbackPrice.setAttribute('data-so-sticky-price', 'true');
    fallbackPrice.textContent = price;
    target.appendChild(fallbackPrice);
  }

  function syncRoot(root) {
    if (!root) return;

    var mainButton = root.querySelector('.so-pdp-atc');
    var mobileButton = root.querySelector('.so-pdp-mobile-buy button[type="submit"]');
    if (!mainButton && !mobileButton) return;

    var variantId = getVariantId(root);
    var available = getAvailability(root, variantId, mainButton);
    var baseText = mainButton && mainButton.dataset.overrideText ? mainButton.dataset.overrideText.trim() : 'Add to cart';
    if (!baseText) baseText = 'Add to cart';
    var price = getVariantPrice(root, variantId);

    syncStickyPrice(root, price, mobileButton);
    setInventoryDisabled(mainButton, !available);
    setInventoryDisabled(mobileButton, !available);

    if (!available) {
      setLabel(mainButton, 'Sold out');
      setLabel(mobileButton, 'Sold out');
      return;
    }

    var builder = root.querySelector('[data-so-bundle-builder][data-bundle-active="true"]');
    if (builder) {
      var bundleCount = Number(builder.dataset.bundleCount || 0);
      var bundleTotal = builder.dataset.bundleTotalLabel || '';
      if (bundleCount > 0) {
        var bundleLabel = 'Add bundle' + (bundleTotal ? ' · ' + bundleTotal : '');
        setLabel(mainButton, bundleLabel);
        setLabel(mobileButton, bundleLabel);
      } else {
        setLabel(mainButton, 'Choose a bundle item');
        setLabel(mobileButton, 'Choose a bundle item');
      }
      return;
    }

    var purchaseLabel = baseText + (price ? ' · ' + price : '');
    setLabel(mainButton, purchaseLabel);
    setLabel(mobileButton, purchaseLabel);
  }

  function syncAll() {
    installStyles();
    document.querySelectorAll('.so-pdp-info').forEach(syncRoot);
  }

  function delayedSync() {
    window.setTimeout(syncAll, SYNC_DELAY_MS);
    window.setTimeout(syncAll, 180);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.so-pdp-variant') || event.target.closest('[data-so-bundle-builder]')) delayedSync();
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.so-pdp-info input[name="id"]')) delayedSync();
  }, true);

  document.addEventListener('shopify:section:load', delayedSync);
  document.addEventListener('DOMContentLoaded', syncAll);

  if (document.readyState !== 'loading') syncAll();

  window.setInterval(function () {
    if (document.querySelector('.so-pdp-info')) syncAll();
  }, 350);
})();
